export const main = (filters) => [
  { text: '', value: 'actions', width: 70 },
  // { text: 'ID', align: 'start', value: 'id', width: '5rem',  
  //     filter: value => {
  //                 if ( !filters.find(x=>x.name === 'id')?.value) return true
  //                 return value == filters.find(x=>x.name === 'id')?.value
  //     }
  // },
  // { text: 'Tháng khởi tạo', align: 'start', value: 'employeeReadyReviewMonth', width: '7rem',
  //     filter: value => true
  // },

  {
    text: 'Mối quan hệ', align: 'start', value: 'employeeFamilyRelationName', width: '4rem',
    filter: value => {
      if (!filters.find(x => x.name === 'employeeFamilyRelationName')?.value) return true
      return value?.includes(filters.find(x => x.name == 'employeeFamilyRelationName')?.value)
    }
  },
  {
    text: 'Mã NS', align: 'start', value: 'employeeCode', width: '4rem',
    filter: value => {
      if (!filters.find(x => x.name === 'employeeCode')?.value) return true
      return value.includes(filters.find(x => x.name === 'employeeCode')?.value)
    }
  },
  {
    text: 'Tên NS', align: 'start', value: 'employeeName', width: '10rem',
    filter: value => {
      if (!filters.find(x => x.name === 'employeeName')?.value) return true
      return value.includes(filters.find(x => x.name === 'employeeName')?.value)
    }
  },
  {
    text: 'Tên người thân', align: 'start', value: 'memberName', width: '7rem',
    filter: value => {
      if (!filters.find(x => x.name === 'memberName')?.value) return true
      return value.includes(filters.find(x => x.name === 'memberName')?.value)
    }
  },

  {
    text: 'Mã NS trong TS', align: 'start', value: 'memberEmployeeCode', width: '7rem',
    filter: value => {
      if (!filters.find(x => x.name === 'memberEmployeeCode')?.value) return true
      return value.includes(filters.find(x => x.name === 'memberEmployeeCode')?.value)
    }
  },
]